import { Alert, Snackbar } from "@mui/material"
import { styles } from "./AppToast.styles"

export const AppToast = ({
  toast,
  onClose,
  autoHideDuration = 6000,
  anchorOrigin = { vertical: "top", horizontal: "right" },
}) => {
  return (
    <Snackbar
      open={Boolean(toast)}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      anchorOrigin={anchorOrigin}
    >
      {toast && (
        <Alert
          onClose={onClose}
          severity={toast.severity}
          sx={styles.appToastAlert}
        >
          {toast.message}
        </Alert>
      )}
    </Snackbar>
  )
}

export default AppToast
